//Shared Service
const getSessionId = async => {
  let userInfo = JSON.parse(localStorage.getItem('Authentication') || '{}');
  if (!userInfo) {
    return null;
  }
  userInfo = userInfo
  return userInfo.id_token;
}

const setToken = async (updatedToken) => {
  let userInfo = JSON.parse(localStorage.getItem('Authentication') || '{}');
  let currentTime = new Date();
  let updatedExpiresToken = new Date(currentTime.setMinutes(currentTime.getMinutes() + (updatedToken.expires_in) / 60));
  if (!userInfo || !updatedToken) {
    return null;
  }
  userInfo.access_token = updatedToken.access_token;
  userInfo.id_token = updatedToken.id_token;
  userInfo.refresh_token = updatedToken?.refresh_token;
  userInfo.expires_in = updatedExpiresToken;  
  localStorage.setItem('Authentication', JSON.stringify(userInfo) || '{}');
};

export function checkStatus(response) {
  
  if (response.status === 401) {
     window.location.href = "/";
    let e = new Error(response.message || 'Token Expired.');
    e.name = "tokenExpired";
    throw e, response.status;
  } else if (response.status === 199) {
    return response;
  } else if (response.status === 403) {
    let e = new Error(response.message);
    e.name = "accessDenied";
    throw e;
  } else if (response.status === 409) {
    let e = new Error(response.message);
    e.name = "duplicateLogin";
    throw e;
  } else if (response.status === 400) {
    let e = new Error(response.message || "Parameter is Missing.");
    throw e;
  }
  else if (response.status !== 200) {
    throw Error(response.message || 'Error in connecting to Server.');
  }
  return response;

}



const isExpired = (exp) => {
  let currentTime = new Date(exp.expires_in);
  let newTime = new Date(currentTime.getTime() - 10 * 1000); 
  if (newTime <= new Date()) {
    return true;
  }
  return false;
};


const getToken = async () => {
  let userInfo = JSON.parse(localStorage.getItem('Authentication') || '{}');
  if (!userInfo) {
    return null;
  }
  let token = userInfo.access_token;
  return token;
};

export async function getHeaders(additionalHeaders = {}, defaultHeaders = ['authorization', 'Content-Type']) {
  let headers = {};
  let Authentication = JSON.parse(localStorage.getItem('Authentication'));
  if (defaultHeaders.indexOf('authorization') !== -1 && Authentication) {
    headers['authorization'] = Authentication.token_type + ' ' + await getToken();
    headers['id_token'] = await getSessionId();
  }
  if (defaultHeaders.indexOf('Content-Type') !== -1) {
    headers['Content-Type'] = "application/json";
  }
  headers = {
    ...headers,
    ...additionalHeaders
  }
  return headers;
}




